<template>
  <div class="add_people">
    <div class="across">
      <div class="line"></div>
      <div class="across-title">{{ title }}</div>
    </div>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="姓名" prop="realName">
        <el-input v-model="ruleForm.realName" placeholder="2-10个字符"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="ruleForm.sex">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="微信号" prop="wxNumber">
        <el-input v-model="ruleForm.wxNumber" placeholder="请输入微信号"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="部门/小组" prop="orgId">
        <el-select v-model="ruleForm.orgId" placeholder="请选择部门/小组">
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in list" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位" prop="position">
        <el-input v-model="ruleForm.position" placeholder="2-8个字符"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="数据权限">
        <el-button class="change_team" @click="changTeam">选择组织</el-button>
        <div class="teams">
          <el-tag type="info" v-for="(item, index) in chooseList" :key="index">
            <span style="color:#000">{{ item.name }}</span>
            <i class="el-icon-error" @click="error_icon(index, item)"></i>
          </el-tag>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" class="save" @click="savebtn('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>

    <dataDialog ref="dataDialog" @organization="organization"></dataDialog>
  </div>
</template>

<script>
import dataDialog from "./dataDialog";
import bus from '../../../components/commonComponents/bus'
import GlobalUtil from '@/utils/globalUtil.js'

export default {
  components: {
    dataDialog
  },
  data() {
    return {
      title: "新增员工",
      ruleForm: {},
      rules: {
        realName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 10, message: "请输入2-10个字符", trigger: "blur" }
        ],
        wxNumber: [
          { required: true, message: "请输入微信号", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        orgId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change"
          },
          {
            pattern: /0?(13|14|15|18|17)[0-9]{9}/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        position: [
          { required: true, message: "请输入职位名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value.length < 2 || value.length > 8) {
                callback(new Error('请输入2-8个字符'));
              } else {
                callback()
              }
            }, trigger: "blur"
          }
        ]
      },
      chooseList: [], // 选择后获取的数组
      list: [] // 组织列表
    };
  },
  methods: {
    // 删除按钮点击事件
    error_icon(idx, id) {
      console.log(idx, id);
      this.chooseList.splice(idx, 1);
      this.ruleForm.authoritySet.splice(idx, 1)
    },
    //
    changTeam() {
      this.$refs.dataDialog.query(this.chooseList)
      this.$refs.dataDialog.dialogTableVisible = true;
    },
    // 保存
    savebtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 判断是新增还是编辑
          if (this.title == "新增员工") {
            // 新增员工
            this.$axios
              .post(this.$url.addUser, this.ruleForm, {
                headers: "application/x-www-form-urlencoded;charset=utf-8"
              })
              .then(res => {
                console.log("我是新增员工", res);
                if (res.code == 0) {
                  this.$message.success("新增成功");
                  this.$router.back();
                }
              });
          } else {
            // 编辑员工
            console.error(this.ruleForm)
            this.$axios.post(this.$url.updateUser, this.ruleForm).then(res => {
              console.log("我是编辑", res);
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.$router.back();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 对话框返回的函数
    organization(value) {
      this.ruleForm["authoritySet"] = []
      this.ruleForm["authoritySet"] = value.map(_ => {
        return _.id;
      });
      this.chooseList = value;
    },

    // 判断是新增还是编辑
    addOrEditor() {
      if (this.$route.query.data == "add") {
        this.title = "新增员工";
      } else {
        this.ruleForm = GlobalUtil.getSessionStorage('rowData')
        this.title = "编辑员工";

        // 获取类目列表
        this.$axios.get(this.$url.getUserInfo, {
          id: this.ruleForm.id
        }).then(res => {
          this.chooseList = res.data.authOrgList.map(_ => {
            let obj = {
              name: _.orgName,
              index: Math.random(),
              mid: _.mid,
              orgId: _.orgId
            }
            return obj
          })
          this.ruleForm["authoritySet"] = res.data.authOrgList.map(_ => { return _.orgId })
          // this.chooseList = res.forEach(_ => {
          //   return this.ruleForm.authorityList.include(_.id);
          // });
        });

      }
    },
    // 获取部门组织列表
    getList() {
      this.$axios.post(this.$url.list, {}).then(res => {
        console.log("组织列表", res);
        this.list = res.data;
      });
    }
    //
  },
  created() {
    // 新增还是编辑
    this.addOrEditor();
    // 获取部门组织列表
    this.getList();
  },
  destroyed() {
    GlobalUtil.removeSessionStorage('rowData')
  }
};
</script>

<style lang='less' scoped>
.add_people {
  padding: 30px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
}

.el-icon-error {
  margin-left: 5px;
  cursor: pointer;
}

.change_team {
  border: 1px solid rgba(89, 204, 225, 1);
  color: rgba(89, 204, 225, 1);
}

.save {
  padding: 12px 30px;
  background: rgba(89, 204, 225, 1);
  border: none;
}

.teams {
  margin-top: 15px;
}

.el-tag {
  margin-right: 15px;
  margin-bottom: 12px;
}

::v-deep .el-input__inner {
  width: 320px;
}

.el-form {
  width: 1000px;
}

.across {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .line {
    width: 3px;
    height: 19px;
    background: rgba(102, 102, 102, 1);
    margin-right: 5px;
  }

  .across-title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
